"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _CustomButton = _interopRequireDefault(require("./Theme1/CustomButton"));

var _Button = _interopRequireDefault(require("./Theme1/Button"));

exports.Button = _Button["default"];

var _Button2 = _interopRequireDefault(require("./Theme8/Button"));

exports.Theme8Button = _Button2["default"];

var _Button3 = _interopRequireDefault(require("./Theme3/Button"));

exports.Theme3Button = _Button3["default"];

var _CustomButton2 = _interopRequireDefault(require("./Theme3/CustomButton"));

var _CustomButton3 = _interopRequireDefault(require("./Theme4/CustomButton"));

var _CustomButton4 = _interopRequireDefault(require("./Theme6/CustomButton"));

var _CustomButton5 = _interopRequireDefault(require("./Theme7/CustomButton"));

var _CustomButton6 = _interopRequireDefault(require("./Theme8/CustomButton"));

var _CustomButton7 = _interopRequireDefault(require("./Theme9/CustomButton"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

exports.getLinkTitle = _utils.getLinkTitle;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(index, _React$PureComponent);

  function index() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = index.prototype;

  _proto.render = function render() {
    var templateId = this.props.templateId;

    if (templateId === 4) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton3["default"], this.props);
    } else if (templateId === 3) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton2["default"], this.props);
    } else if (templateId === 6) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton4["default"], this.props);
    } else if (templateId === 7) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton5["default"], this.props);
    } else if (templateId === 8) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton6["default"], this.props);
    } else if (templateId === 9) {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton7["default"], this.props);
    } else {
      return /*#__PURE__*/_react["default"].createElement(_CustomButton["default"], this.props);
    }
  };

  return index;
}(_react["default"].PureComponent);

var _default = index;
exports["default"] = _default;